var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTop1Creator = function SvgTop1Creator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-1-creator_svg__a)",
    fillRule: "evenodd",
    d: "M27.474 29.182 18.192 19.9.775 37.318a.75.75 0 0 0 .471 1.279c1.54.118 3.617.28 3.617.28l4.713-1.058-1.07 4.681s.159 2.08.274 3.623a.75.75 0 0 0 1.28.472z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-1-creator_svg__b)",
    fillRule: "evenodd",
    d: "m20.526 29.182 9.282-9.282 17.417 17.418a.75.75 0 0 1-.471 1.279c-1.54.118-3.617.28-3.617.28l-4.305-.65.662 4.273s-.159 2.08-.274 3.623a.75.75 0 0 1-1.28.472z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-1-creator_svg__c)",
    fillRule: "evenodd",
    d: "m4.815 38.8 16.14-16.139 3.63 3.63-16.14 16.14-.222-3.387z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-1-creator_svg__d)",
    fillRule: "evenodd",
    d: "m43.186 38.8-16.14-16.139-3.63 3.63 16.14 16.14.222-3.387z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-1-creator_svg__e)",
    fillRule: "evenodd",
    d: "M29.55 6.365a1.96 1.96 0 0 1 1.38.572c1.642 1.645 6.368 6.375 8.011 8.018.366.366.57.861.571 1.379-.002 2.323-.004 9.01-.003 11.334a1.96 1.96 0 0 1-.572 1.38c-1.645 1.641-6.375 6.368-8.017 8.011-.367.366-.862.57-1.38.57-2.323 0-9.01-.003-11.334-.002a1.96 1.96 0 0 1-1.38-.572l-8.01-8.018a1.96 1.96 0 0 1-.572-1.379c.002-2.323.004-9.01.004-11.334a1.96 1.96 0 0 1 .571-1.38c1.645-1.642 6.375-6.368 8.018-8.011.367-.366.861-.57 1.379-.57 2.323 0 9.01.003 11.334.002",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-1-creator_svg__f)",
    fillRule: "evenodd",
    d: "M28.555 9.87a.87.87 0 0 1 .618.256c1.105 1.106 5.454 5.454 6.558 6.56a.88.88 0 0 1 .257.62l-.002 9.277a.87.87 0 0 1-.256.617c-1.106 1.106-5.454 5.455-6.56 6.559a.88.88 0 0 1-.62.257l-9.277-.002a.87.87 0 0 1-.617-.256c-1.106-1.106-5.455-5.455-6.558-6.56a.88.88 0 0 1-.258-.621l.002-9.276a.87.87 0 0 1 .256-.617l6.56-6.559a.88.88 0 0 1 .621-.257z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-1-creator_svg__g)",
    fillRule: "evenodd",
    d: "m28.578 10.876 6.483 6.484v9.168l-6.484 6.483h-9.169l-6.483-6.484v-9.169l6.484-6.483z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#763C00",
    d: "M23.812 8.794a.714.714 0 1 0 0-1.428.714.714 0 0 0 0 1.428M33.225 12.792a.714.714 0 1 0 1.01-1.01.714.714 0 0 0-1.01 1.01M36.94 21.908a.714.714 0 1 0 1.428 0 .714.714 0 0 0-1.428 0M32.941 31.318a.714.714 0 1 0 1.01 1.01.714.714 0 0 0-1.01-1.01M23.826 35.033a.714.714 0 1 0 0 1.428.714.714 0 0 0 0-1.428M14.416 31.035a.714.714 0 1 0-1.01 1.01.714.714 0 0 0 1.01-1.01M10.7 21.921a.714.714 0 1 0-1.427 0 .714.714 0 0 0 1.427 0M14.699 12.509a.714.714 0 1 0-1.01-1.01.714.714 0 0 0 1.01 1.01"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-1-creator_svg__a",
    x1: 16.212,
    x2: 8.508,
    y1: 34.795,
    y2: 42.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E70002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF696A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-1-creator_svg__b",
    x1: 31.788,
    x2: 39.492,
    y1: 34.795,
    y2: 42.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E70002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF696A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-1-creator_svg__c",
    x1: 16.008,
    x2: 6.593,
    y1: 31.243,
    y2: 40.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-1-creator_svg__d",
    x1: 31.993,
    x2: 41.408,
    y1: 31.243,
    y2: 40.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-1-creator_svg__e",
    x1: 35.667,
    x2: 12.091,
    y1: 8.091,
    y2: 35.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-1-creator_svg__f",
    x1: 20.595,
    x2: 28.711,
    y1: 16.067,
    y2: 24.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "top-1-creator_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(65.23 .79 19.92)scale(25.5265)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732300"
  })))));
};
export default SvgTop1Creator;